//import $ from 'jquery';

export const HEADER_SELECTOR        = '.main-header';
export const EDITION_COOKIE         = 'voc_edtn';
export const COOKIE_DOMAIN          = `.${Voonto.getInstance().lookup('vocento.site').tlddomain}`;
export const EDITION_COOKIE_OPTIONS = {domain: COOKIE_DOMAIN, path: '/', expires: 7};

export const SWIPER_DEFAULTS = {
  pagination:          '.swiper-pagination',
  nextButton:          '.swiper-button-next',
  prevButton:          '.swiper-button-prev',
  slidesPerView:       4,
  centeredSlides:      false,
  paginationClickable: true,
  spaceBetween:        0,
  grabCursor:          true,
  preloadImages:       false,
  lazyLoading:         true,
  loop:                true,
  breakpoints: {
    // when window width is <= 700px
    700: {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 2,
      coverflow: {
        stretch: 0,
        depth: 100,
        modifier: 1,
      }
    }
  }
};

export const SWIPER_FRACTION = $.extend({}, SWIPER_DEFAULTS, {
  keyboardControl: true,
  slidesPerView: 1,
  paginationType : 'fraction',
  loop : false,
  paginationFractionRender: function (swiper, currentClassName, totalClassName) {
    return '<span class="' + currentClassName + '"></span>' +
           ' de ' +
           '<span class="' + totalClassName + '"></span>';
  },
  breakpoints: {
    700: {
      centeredSlides: false,
      slidesPerView: 1
    }
  }
});

export const SWIPER_2ROWS = $.extend({}, SWIPER_DEFAULTS, {
  breakpoints: {
    700: {
      centeredSlides:   false,
      loop:             false,
      pagination:       '.swiper-pagination',
      slidesPerView:    2,
      slidesPerColumn:  2
    }
  }
});

export const SWIPER_AUTO = $.extend({}, SWIPER_DEFAULTS, {
  slidesPerView: 'auto',
  breakpoints: {
    700: {
      centeredSlides: false,
      slidesPerView: 'auto',
      grabCursor: true
    }
  }
});

export const SWIPER_ADV = $.extend({}, SWIPER_DEFAULTS, {
  slidesPerView: 2.2,
  noSwipingClass:'.swiper-container',
  breakpoints: {
    1900: {
      slidesPerView: 5,
      spaceBetween: 0,
      simulateTouch: false,
      noSwiping:true
    },
    700: {
      spaceBetween: 1,
      noSwiping:false
    }
  }
});

export const SWIPER_NAV = $.extend({}, SWIPER_DEFAULTS, {
  slidesPerView: 1,
  pagination: '.club-pagination',
  noSwipingClass:'.swiper-container',
  breakpoints: {
    1900: {
      slidesPerView: 3,
      spaceBetween: 20,
      simulateTouch: false,
      paginationClickable: false,
      noSwiping:true,
    },
    800: {
      slidesPerView: 3,
      simulateTouch: false,
      spaceBetween: 30,
      paginationClickable: false,
      noSwiping:true,
    },
    700: {
      spaceBetween: 100,
      noSwiping:false,
      paginationClickable: true,
    }
  }
});

export const SWIPER_ON_PLUS = $.extend({}, SWIPER_DEFAULTS, {
  slidesPerView: 3,
  spaceBetween: 12,
  breakpoints: {
    1039: {
      slidesPerView: 2
    },
    700: {
      slidesPerView: 1
    }
  }
});

export const SCROLL_HANDLER = 'ontouchmove' in document.documentElement ? 'touchmove' : 'scroll';
export const WINDOW_DELIMITER_WIDTH = 700;



// WEBPACK FOOTER //
// ./src/constants.js